import React, { Fragment } from 'react'
import PromoTeaser from 'components/common/PromoTeaser'
import PropTypes from 'prop-types'

const PromotionTeaser = ({
  promotions
}) =>
  <Fragment>
    {
      promotions.map(({
        displayName,
        promotionName,
        promoId,
        promotionId,
        promotionType,
        promotionRebate
      }, index) =>
        <PromoTeaser
          creative={ 'tire-recommended-results' }
          item={ promotions[index] }
          key={ index }
          promotionId={ promoId || promotionId }
          promotionRebate={ promotionRebate }
          promotionType={ promotionType } >
          {displayName || promotionName}
        </PromoTeaser>
      )
    }
  </Fragment>
PromotionTeaser.propTypes = {
  promotions: PropTypes.arrayOf(PropTypes.shape())
}
export default PromotionTeaser
